/* ==========================================
   Aetheris — Theme JS
   ========================================== */

'use strict';

// ── Scroll Reveal ────────────────────────
function observeScroll() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    { threshold: 0.1 }
  );
  document.querySelectorAll('.scroll-reveal').forEach((el) => observer.observe(el));
}

// ── Mobile Menu ──────────────────────────
function initMobileMenu() {
  const btn  = document.getElementById('mobile-menu-btn');
  const menu = document.getElementById('mobile-menu');
  if (!btn || !menu) return;
  btn.addEventListener('click', () => {
    menu.classList.toggle('hidden');
    btn.setAttribute('aria-expanded', !menu.classList.contains('hidden'));
  });
}

// ── Canvas: Molecular Synchronization ────
function initMolecularCanvas() {
  const canvas = document.getElementById('canvas-molecular');
  if (!canvas) return;

  const ctx    = canvas.getContext('2d');
  const dpr    = window.devicePixelRatio || 1;
  const parent = canvas.parentElement;
  const w = parent.offsetWidth;
  const h = parent.offsetHeight || w; 
  if (w === 0) return;
  canvas.width  = w * dpr;
  canvas.height = h * dpr;
  ctx.scale(dpr, dpr);
  const rect = { width: w, height: h };

  const gridSize     = 8;
  const particleCount = gridSize * gridSize;
  const spacing       = rect.width / (gridSize + 1);

  const particles = [];
  for (let i = 0; i < particleCount; i++) {
    particles.push({
      x:       Math.random() * rect.width,
      y:       Math.random() * rect.height,
      targetX: spacing + (i % gridSize) * spacing,
      targetY: spacing + Math.floor(i / gridSize) * spacing,
      vx:      (Math.random() - 0.5) * 1,
      vy:      (Math.random() - 0.5) * 1,
    });
  }

  function animate() {
    ctx.clearRect(0, 0, rect.width, rect.height);
    const t = (Math.sin(Date.now() * 0.0008) + 1) / 2;
    ctx.strokeStyle = 'rgba(166, 124, 82, 0.15)';
    ctx.lineWidth   = 0.5;

    particles.forEach((p, i) => {
      p.x += p.vx; p.y += p.vy;
      if (p.x < 0 || p.x > rect.width)  p.vx *= -1;
      if (p.y < 0 || p.y > rect.height) p.vy *= -1;

      const dx = p.x * (1 - t) + p.targetX * t;
      const dy = p.y * (1 - t) + p.targetY * t;

      ctx.beginPath();
      ctx.arc(dx, dy, 1.5, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(166, 124, 82, ${0.3 + t * 0.7})`;
      ctx.fill();

      particles.slice(i + 1).forEach((p2) => {
        const dx2  = p2.x * (1 - t) + p2.targetX * t;
        const dy2  = p2.y * (1 - t) + p2.targetY * t;
        const dist = Math.hypot(dx - dx2, dy - dy2);
        if (dist < spacing * 1.5) {
          ctx.beginPath();
          ctx.moveTo(dx, dy);
          ctx.lineTo(dx2, dy2);
          ctx.stroke();
        }
      });
    });
    requestAnimationFrame(animate);
  }
  animate();
}

// ── Canvas: Incoherence Filtering ────────
function initFilteringCanvas() {
  const canvas = document.getElementById('canvas-filtering');
  if (!canvas) return;

  const ctx    = canvas.getContext('2d');
  const dpr    = window.devicePixelRatio || 1;
  const parent = canvas.parentElement;
  const w = parent.offsetWidth;
  const h = parent.offsetHeight || Math.round(w * 9/16);
  if (w === 0) return;
  canvas.width  = w * dpr;
  canvas.height = h * dpr;
  ctx.scale(dpr, dpr);
  const rect = { width: w, height: h };

  let offset = 0;
  function animate() {
    ctx.fillStyle = '#1A1A1A';
    ctx.fillRect(0, 0, rect.width, rect.height);
    offset += 2;

    ctx.beginPath();
    ctx.strokeStyle = '#A67C52';
    ctx.lineWidth   = 2;
    for (let x = 0; x < rect.width; x++) {
      const y = rect.height / 2 + Math.sin((x + offset) * 0.02) * 20;
      x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
    }
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
    ctx.lineWidth   = 1;
    for (let x = 0; x < rect.width; x++) {
      const noiseAmt = ((rect.width - x) / rect.width) * 50;
      const noise    = (Math.random() - 0.5) * noiseAmt;
      const y = rect.height / 2 + Math.sin((x + offset) * 0.04) * 30 + noise;
      x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
    }
    ctx.stroke();

    requestAnimationFrame(animate);
  }
  animate();
}

// ── Cart: AJAX Add to Cart ────────────────
async function addToCart(variantId, quantity) {
  quantity = quantity || 1;
  try {
    const res = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity }),
    });
    if (!res.ok) throw new Error('Cart error');
    await updateCartCount();
    // Automatically open the drawer after adding an item
    if (typeof openCart === 'function') openCart();
  } catch (err) {
    console.error('Add to cart error:', err);
  }
}

async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });
  } catch (err) {
    console.error('Cart count error:', err);
  }
}

// ── Cart Drawer Logic ──────────────────────
let isCartOpen = false;

function initCartDrawer() {
  const toggle  = document.getElementById('cart-toggle');
  const drawer  = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const closeBtn= document.getElementById('cart-close');

  if (!drawer) return;

  window.openCart = function() {
    isCartOpen = true;
    drawer.classList.add('open');
    if (overlay) overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    fetchCartContents();
  }

  window.closeCart = function() {
    isCartOpen = false;
    drawer.classList.remove('open');
    if (overlay) overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  if (toggle) toggle.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay)  overlay.addEventListener('click', closeCart);
  
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });
}

async function fetchCartContents() {
  const body       = document.getElementById('cart-body');
  const subtotalEl = document.getElementById('cart-subtotal-amount');
  if (!body) return;

  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();

    if (subtotalEl) {
      subtotalEl.textContent = (cart.total_price / 100).toLocaleString('en-US', {
        style: 'currency', currency: cart.currency
      });
    }

    if (cart.items.length === 0) {
      body.innerHTML = '<p style="font-size:0.875rem;font-weight:300;color:#a1a1aa;text-align:center;padding:2rem 0;">Your sanctuary is empty.</p>';
      return;
    }

    body.innerHTML = cart.items.map((item) => {
      return `
        <div style="display:flex;gap:1rem;padding:1rem 0;border-bottom:1px solid #f4f4f5;align-items:flex-start;">
          ${item.image ? `<img src="${item.image}" alt="" style="width:64px;height:64px;object-fit:cover;flex-shrink:0;">` : ''}
          <div style="flex:1;min-width:0;">
            <p style="font-size:0.8125rem;font-weight:400;margin:0 0 0.25rem;">${item.product_title}</p>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:10px;color:#a1a1aa;letter-spacing:0.1em;text-transform:uppercase;margin:0 0 0.5rem;">${item.variant_title}</p>` : ''}
            <div style="display:flex;justify-content:space-between;align-items:center;">
              <p style="font-size:0.8125rem;font-weight:300;margin:0;">${(item.final_line_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency })}</p>
              <div style="display:flex;align-items:center;gap:0.5rem;">
                <button onclick="updateCartItem('${item.key}', ${item.quantity - 1})" style="background:none;border:1px solid #e4e4e7;width:24px;height:24px;cursor:pointer;">−</button>
                <span style="font-size:0.8125rem;min-width:1.5rem;text-align:center;">${item.quantity}</span>
                <button onclick="updateCartItem('${item.key}', ${item.quantity + 1})" style="background:none;border:1px solid #e4e4e7;width:24px;height:24px;cursor:pointer;">+</button>
              </div>
            </div>
          </div>
        </div>`;
    }).join('');
  } catch(err) {
    console.error('Cart error:', err);
    body.innerHTML = '<p style="font-size:0.875rem;color:#a1a1aa;text-align:center;padding:2rem 0;">Could not load cart.</p>';
  }
}

window.updateCartItem = async function(key, qty) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await res.json();
    fetchCartContents();
    updateCartCount();
  } catch(err) {
    console.error('Cart update error:', err);
  }
}

// ── Init ─────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  observeScroll();
  initMobileMenu();
  initMolecularCanvas();
  initFilteringCanvas();
  initCartDrawer();
  updateCartCount(); // Sync count on load
});